"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contract = void 0;
const zod_1 = require("zod");
exports.Contract = zod_1.z.union([
    zod_1.z.literal('protocolForwarder'),
    zod_1.z.literal('credentialRegistry'),
    zod_1.z.literal('campaignRegistry'),
    zod_1.z.literal('adMatcher'),
    zod_1.z.literal('revShare'),
    zod_1.z.literal('revShareStats'),
    zod_1.z.literal('adBudget'),
]);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udHJhY3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2NoZW1hL2NvbnRyYWN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDZCQUF1QjtBQUVWLFFBQUEsUUFBUSxHQUFHLE9BQUMsQ0FBQyxLQUFLLENBQUM7SUFDOUIsT0FBQyxDQUFDLE9BQU8sQ0FBQyxtQkFBbUIsQ0FBQztJQUM5QixPQUFDLENBQUMsT0FBTyxDQUFDLG9CQUFvQixDQUFDO0lBQy9CLE9BQUMsQ0FBQyxPQUFPLENBQUMsa0JBQWtCLENBQUM7SUFDN0IsT0FBQyxDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQUM7SUFDdEIsT0FBQyxDQUFDLE9BQU8sQ0FBQyxVQUFVLENBQUM7SUFDckIsT0FBQyxDQUFDLE9BQU8sQ0FBQyxlQUFlLENBQUM7SUFDMUIsT0FBQyxDQUFDLE9BQU8sQ0FBQyxVQUFVLENBQUM7Q0FDdEIsQ0FBQyxDQUFBIn0=